import { SimpleChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { Router, NavigationEnd } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Component, ElementRef, HostBinding, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { AnimationBuilder, AnimationPlayer } from '@angular/animations';

import { Activo } from '../../../core/modelos/activo';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { MapaService } from '../mapa/mapa.service';
import * as L from 'leaflet';
import { FileManagerService } from '../../content/file-manager/file-manager.service';
import { ActivosService } from '../../content/activos/activos.service';
import { FiltersService } from '../../content/filters/filters.service';

import { locale as english } from '../../../i18n/en';
import { locale as spanish } from '../../../i18n/es';
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service';

@Component({
    selector: 'fuse-panel-info',
    templateUrl: './panel-info.component.html',
    styleUrls: ['./panel-info.component.scss']
})
export class PanelInfoComponent implements OnInit, OnChanges {
    marcadoresActivos: L.Marker[];

    @ViewChild('panel') panel;
    @ViewChild('searchInput') searchInput: ElementRef;

    // Variable que indica la pantalla donde estamos
    @Input() pantalla: string;

    // Variable que indica el indice del marcador pinchado para mostrar project card
    @Input() indexPopup: number;

    // Variable que manda el índice del item seleccionado para resaltar marcador en mapa
    @Output() indexSeleccion = new EventEmitter<number>();

    @Output() itemSeleccion = new EventEmitter<Activo>();

    // Variable que indica si estamos mostrando listado o detalle de Asset.
    verDetalle: boolean;

    // Variable que contiene datos del asset seleccionado
    seleccion: any;

    // Variable con el listado de activos.
    @Input() listaAssets: Array<Activo>;
    // Variable con el listado de activos, para buscar activo seleccionado y mostrar en projectCard
    listaAssets2: Array<Activo>;
    // Variable con el listado filtrado de activos
    listaFiltrada: any;

    itemsLength: number;

    @Input() idActivo: number;

    public player: AnimationPlayer;

    imagenGrande: string;

    loadingImagen = false;

    showInput: boolean = false;

    @HostBinding('class.bar-closed') barClosed: boolean;

    hoverIndex: number;
    zoomMarkers: L.Marker[];

    constructor(
        private translationLoader: FuseTranslationLoaderService,
        private animationBuilder: AnimationBuilder,
        private cookieService: CookieService,
        private router: Router,
        private activosService: ActivosService,
        private notificaciones: NotificacionesService,
        private mapaService: MapaService,
        private filtersService: FiltersService,
        private fileManagerService: FileManagerService
    ) {
        this.verDetalle = false;
        this.barClosed = false;
        this.translationLoader.loadTranslations(english, spanish);

        this.getActivos();

        this.router.events.subscribe((e: any) => {
          // If it is a NavigationEnd event re-initalise the component
          if (e instanceof NavigationEnd) {
              this.mostrarListado();
              this.verDetalle = false;
          }
        });

        // Listen map markers events
        this.mapaService.hoverMarker.subscribe(index => this.hoverIndex = index)
        this.mapaService.zoomMarker.subscribe(markers => this.filterAssetsByZoom(markers))

        // Listen filters
        this.filtersService.filters.subscribe(filters => this.filterAssetsByField(filters))
    }

    ngOnInit() {
        // Capa que cubre resto página.
        /* this.renderer.listen(this.overlay.nativeElement, 'click', () => {
            this.closeBar();
        }); */
    }

    goTickets(idActivo: number) {
        localStorage.setItem('activoSeleccionadoId', String(idActivo));
        this.router.navigate(['/tickets', idActivo]);
    }

    onClickSearch(): void {
      this.showInput = !this.showInput;
      setTimeout(() => this.searchInput.nativeElement.focus(), 100)
    }

    ngOnChanges(changes: SimpleChanges) {

        /* Muestra detalle de activo al pulsar un marcador en el mapa. */

        if (changes.indexPopup && !changes.indexPopup.firstChange) {
            
            setTimeout(() => {
                
                const currentValue = changes.indexPopup.currentValue;
                
                if (currentValue !== undefined) {
                    this.mostrarListado();
                    this.mostrarDetalle(currentValue);
                }

            }, 0);

        }

    }

    getActivos() {
        this.activosService.getActivos().subscribe(
            data => {
                if (data.success) {
                    // this.activosService.putAssetOnCache({...data});
                    // Controlo la foto para que se vea
                    if (data.items.length > 0) {
                        data.items.forEach(activo => {
                            activo.thumbnail = activo.thumbnail &&
                                activo.thumbnail.indexOf('data:image/jpeg;base64,') === -1 ? 'data:image/jpeg;base64,' + activo.thumbnail : activo.thumbnail;
                        });
                    }

                    this.listaAssets = data.items;
                    this.listaAssets2 = data.items;
                    this.listaFiltrada = this.listaAssets;
                    this.itemsLength = this.listaAssets.length;

                    setTimeout(() => {
                        if (this.pantalla === 'portfolio') {

                            // En 'portfolio' se despliega projectCard
                            this.openBar();

                        } else if (this.pantalla === 'dashboard') {

                            // En 'dashboard' se muestra el detalle del activo que se esté viendo

                            this.listaAssets2.filter((x, i) => {

                                if (+x.id === +this.idActivo) {
                                    this.idActivo = i;

                                    // notify about the new activo
                                    this.activosService.setCurrentActivo(this.idActivo)
                                }
                            });

                            this.mostrarDetalle(this.idActivo);
                        } else {
                            // if (localStorage.getItem('activoSeleccionadoId')) {
                            //     this.mostrarDetalle(-1, +localStorage.getItem('activoSeleccionadoId'));
                            // }
                        }
                    }, 0);

                    this.marcadoresActivos = this.mapaService.marcadoresActivos;

                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ErrorDesconocido);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    closeBar() {
        // this.player =
        //     this.animationBuilder
        //         .build([
        //             style({ transform: 'translate3d(0,0,0)' }),
        //             animate('400ms ease', style({ transform: 'translate3d(100%,0,0)' }))
        //         ]).create(this.panel.nativeElement);
        //
        // this.player.play();
        //
        // this.player.onDone(() => {
        //     this.barClosed = true;
        // });
    }

    openBar() {
        // this.barClosed = false;
        //
        // this.player =
        //     this.animationBuilder
        //         .build([
        //             style({ transform: 'translate3d(100%,0,0)' }),
        //             animate('400ms ease', style({ transform: 'translate3d(0,0,0)' }))
        //         ]).create(this.panel.nativeElement);
        //
        // this.player.play();
    }

    mostrarDetalle(e: any, id?: number) {

        this.loadingImagen = true;

        this.verDetalle = true;

        if (e === -1) {
            // Si se ejecuta porque se ha guardado el id al seleccionar antes, se tiene que buscar.
            const asset = this.listaAssets.filter(
                activo => activo.id === id
            );
            this.seleccion = asset[0];
        } else {
            this.seleccion = this.listaFiltrada.find(
                activo => activo.id === e
            );
        }


        // En el momento que tengo el activo seleccionado solicito su imagen real

        // if (this.seleccion) {
        //     this.activosService.getActivoImagen(this.seleccion.id).subscribe(data => {
        //         if (this.seleccion) {
        //             this.seleccion.imagen = data.items ? 'data:image/jpeg;base64,' + data.items : null;
        //             this.loadingImagen = false;
        //         }
        //     });
        // }

        const indiceSinFiltrar = this.listaAssets.indexOf(this.listaFiltrada.find(
            activo => activo.id === e
        ));

        if (this.pantalla === 'portfolio') {

            this.indexSeleccion.emit(indiceSinFiltrar);
            this.itemSeleccion.emit(this.seleccion);

            // this.marcadoresActivos[e].openPopup();

            if (id) {
                this.filtrarPopup(id);
            }
        }

        if (this.seleccion) {
            localStorage.setItem('activoSeleccionadoId', this.seleccion.id);
        } else {
            this.mostrarListado();
        }

        // Directamente abro dashboards
        this.verDashboard(this.seleccion)

    }

    mostrarListado(cerrar?: boolean) {
        this.verDetalle = false;
        this.listaFiltrada = this.listaAssets;
        this.seleccion = undefined;

        if (this.pantalla === 'portfolio') {

            this.indexSeleccion.emit(-1);

            if (cerrar) {

                this.marcadoresActivos.map(
                    m => m.closePopup()
                );
            }
        }
    }

    filtrarPopup(id: number) {

        this.marcadoresActivos.filter(
            m => {
                if (+m.options.alt === id) {

                    const latLngs = m.getLatLng();
                    const bounds = L.latLngBounds(latLngs, latLngs);

                    this.mapaService.centrar(bounds);
                    m.openPopup();
                    // m.fireEvent('click');
                }
            }
        );


        // Mobile devices
        this.filtersService.activate('map')
    }

    search(value) {
        this.listaFiltrada = this.listaAssets.filter((m) => {
            let kpiFilt;
            m.kpis.forEach(kpi => {
                if (kpi.descripcion.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
                    kpiFilt = true;
                }
                else if (kpi.valor.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
                    kpiFilt = true;
                }
            });
            return m.nombre.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
            m.codigo.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
            m.cliente.nombre.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
            m.ciudad.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
            m.tipologia.nombre.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
            m.estado.nombre.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
            m.sector.nombre.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
            kpiFilt === true;
        });
    }

    verDashboard(activoSeleccionado: Activo) {
        this.router.navigate(['/dashboard', activoSeleccionado.id]);
    }

    goToDocs(seleccion: Activo) {
        localStorage.setItem('activoSeleccionadoId', String(seleccion.id));
        if (seleccion.carpetaAWS) {
            this.fileManagerService.setCarpetaDestino(seleccion.carpetaAWS);
            this.router.navigate(['/docs', seleccion.id]);
        }
        else {
            // Mostrar error
            alert('El activo no tiene carpeta asociada');
        }

    }

    goToViewer(seleccion: Activo) {
        this.router.navigate(['/3d-viewer', { enlace: seleccion.enlace, id: seleccion.id }], { skipLocationChange: true });
    }

    isMapMarkerHover(assetId: number) {
        return (this.hoverIndex !== undefined && this.hoverIndex === assetId)
    }

    filterAssetsByZoom(markers: L.Marker[]) {
        const markersId = markers.map((m: L.Marker) => +m.options.alt)
        if(this.listaAssets !== undefined) {
          this.listaFiltrada = this.listaAssets.filter(m => markersId.includes(m.id))
        } else {
          this.listaFiltrada = [];
        }
        this.itemsLength = this.listaFiltrada.length;
        this.marcadoresActivos = this.mapaService.marcadoresActivos;
    }

    filterAssetsByField(filters: Array<any>) {
        // https://stackoverflow.com/questions/8051975/access-object-child-properties-using-a-dot-notation-string
        const getDescendantProp = (obj, desc) => {
            const arr = desc.split(".");
            while(arr.length && (obj = obj[arr.shift()]));
            return obj;
        }

        const getKPI = (obj, description) => {
          let found = null;
          found = obj.kpis.find(k => k.descripcion === description);
          if(found) {
            return found.valor;
          } else {
            return null;
          }
        }

        // https://stackoverflow.com/questions/48834275/good-way-to-chain-filter-functions-in-javascript
        const filterFn = asset => {
            // Store all filtered conditions
            const conditionClauses = []
            filters.forEach(f => {

                // TODO: assuming the key is an array of two elements
                if (f.key instanceof Array && f.value.length) {
                    const fn = x => {
                        const key1 = getDescendantProp(x, f.key[0])
                        const key2 = getDescendantProp(x, f.key[1])
                        return (key1.toLowerCase().indexOf(f.value.toLowerCase()) !== -1) ||
                          (key2.toLowerCase().indexOf(f.value.toLowerCase()) !== -1)
                    }
                    conditionClauses.push(fn)
                } else if ((typeof f.value === "string" || f.value instanceof String) && f.value.length) {
                    const fn = x => {
                        const key = getDescendantProp(x, f.key)
                        return key.toLowerCase().indexOf(f.value.toLowerCase()) !== -1
                    }
                    conditionClauses.push(fn)
                } else if (f.value instanceof Array && f.value.length) {
                    const fn = x => {
                        const key = getDescendantProp(x, f.key)
                        return f.value.includes(key)
                    }
                    conditionClauses.push(fn)
                } else if (f.value instanceof Object && (f.value.hasOwnProperty('max') && f.value.hasOwnProperty('min'))) {
                    const { max, min } = f.value
                    const fn = x => {
                        const key = parseFloat(getKPI(x, f.key))
                        return key >= min && key <= max
                    }
                    conditionClauses.push(fn)
                }
            })

            return conditionClauses.every(f => f(asset))
        }

        this.listaFiltrada = this.listaAssets.filter(filterFn)
        this.itemsLength = this.listaFiltrada.length;

        this.mapaService.updateMarkers(this.listaFiltrada)
        this.marcadoresActivos = this.mapaService.marcadoresActivos;
    }

    highlightMarker(id: number) {
        this.marcadoresActivos.filter(
            m => {
                if (+m.options.alt === id) {
                    const element = m.getElement()
                    const className = "is-hovered"

                    if (element.classList.contains(className)) {
                        element.classList.remove(className)
                    } else {
                        element.classList.add(className)
                    }
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/main/components/panel-info/panel-info.component.ts